window.chdBoostMarketPriceData = function (data, currency, baseCurrency) {
    var localized = Object.assign({}, data);
    var active = String(currency || baseCurrency || '').toLowerCase();
    var base = String(baseCurrency || '').toLowerCase();
    ['price_min', 'price_max', 'compare_at_price_min', 'compare_at_price_max'].forEach(function (key) {
        var value = data[key + '_' + active];
        if (value == null && active === base) value = data[key];
        localized[key] = value !== '' && value != null && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
    });
    return localized;
};
